export const DEFAULT_PROJECT_ORDERING = "-created"

export const UNKNOWN_CREATOR = "Unknown"

export const creatorLabel = (name?: string | null): string =>
  name || UNKNOWN_CREATOR
